// extracted by mini-css-extract-plugin
export default {"identityStatusCondition":"IdentityStatusCondition_identityStatusCondition__W86+4"};